import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client/realm-context';
import type { RouteGuardOptions } from '../../../util/routing/guard';

export const Route = createFileRoute('/_app/_o5/_o5-required')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.O5] } },
  } as const satisfies RouteGuardOptions,
  preload: false,
});
